<template>
  <div class="columns">
    <div class="column is-narrow release">
      <p v-if="false">
        {{ release.description }}
      </p>
      <figure class="image is-square margin-bottom release-artwork">
        <img :src="release.cover_thumbnail">
      </figure>
      <p class="text label-medium">
        {{ release.display_title }}
      </p>
    </div>
    <div class="column">
      <track-list-item
        v-for="track in orderedNoInstrumentalVersionTracks"
        :key="track.pk"
        :show-cover="false"
        :show-artist="false"
        :show-waveform="true"
        :show-tags="true"
        :track="track"
      />
    </div>
  </div>
</template>

<script>
import TrackListItem from '@/components/TrackListItem.vue'

export default {
  name: 'ReleaseListItem',

  components: {
    TrackListItem
  },

  props: {
    release: {
      type: Object,
      required: true
    }
  },

  computed: {
    orderedTracks: function () {
      return this.release.tracks
        .concat()
        .sort((a, b) =>
          a.track_number > b.track_number
            ? 1
            : b.track_number > a.track_number
              ? -1
              : 0
        )
    },

    orderedNoInstrumentalVersionTracks: function () {
      return this.orderedTracks.filter((track) => track.is_instrumental_version === false)
    }
  },

  methods: {
    trackRouteTo: function (track) {
      return {
        name: 'track-detail',
        params: {
          slug: track.slug,
          artistSlug: this.release.artist.slug,
          trackId: track.pk
        }
      }
    }
  }
}
</script>

<style>
</style>
